<template>
	<div class="page">
		<!-- <van-nav-bar title="详情" :left-arrow="canBack" @click-left="onClickLeft" /> -->
		<div class="prview-content">
			<div class="title">{{notify.title}}</div>
			<div class="author">{{notify.createTime}}</div>
			<div class="content" v-html="notify.content"></div>
		</div>
	</div>
</template>

<style scoped="scoped">
</style>
<script>
	import {
		getDetail
	} from '@/api/news.js'

	export default {
		name: 'News',
		components: {},
		data() {
			return {
				notify: {},
				canBack: false,
			}
		},
		methods: {
			onClickLeft() {
				this.$router.go(-1)
			}
		},
		mounted() {
		},
		created() {
			const id = this.$route.query.id;
			this.canBack = !!this.$route.query.canBack
			getDetail({
				id
			}).then((rep) => {
				this.notify = rep.data;
			})
		}
	}
</script>
